import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const BasicInformationForm = ({
  formData,
  errors,
  templateName,
  safeTrafficAllocation,
  isActive,
  onInputChange,
}) => {
  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Description"
          value={formData.description}
          onChange={e => onInputChange('description', e.target.value)}
          multiline
          rows={2}
        />
      </Grid>

      <Grid
        container
        spacing={2}
        alignItems="flex-end"
        sx={{ width: '100%', margin: 0 }}
      >
        <Grid
          size={{ xs: 12, md: 3.5 }}
          sx={{ display: 'flex', alignItems: 'flex-end', paddingLeft: 0 }}
        >
          <TextField
            fullWidth
            size="small"
            margin="dense"
            label="Experiment Name"
            value={formData.name}
            onChange={e => onInputChange('name', e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            required
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              },
              '& .MuiInputBase-input': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              },
            }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 3.5 }}
          sx={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <TextField
            fullWidth
            size="small"
            margin="dense"
            label="Template *"
            value={templateName}
            disabled
            required
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              },
            }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 1.75 }}
          sx={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <FormControl
            fullWidth
            size="small"
            margin="dense"
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              },
            }}
          >
            <InputLabel sx={{ fontSize: '0.875rem' }}>
              Traffic Allocation
            </InputLabel>
            <Select
              value={safeTrafficAllocation}
              onChange={e =>
                onInputChange('traffic_allocation', e.target.value)
              }
              displayEmpty
              disabled={isActive}
            >
              <MenuItem value="equal_split">Equal Split</MenuItem>
              <MenuItem value="weighted_split">Weighted Split</MenuItem>
              <MenuItem value="single_treatment">Single Treatment</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid
          size={{ xs: 12, md: 1.75 }}
          sx={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <TextField
            fullWidth
            size="small"
            margin="dense"
            label="Minimum Sample Size"
            type="number"
            value={formData.minimum_sample_size}
            onChange={e =>
              onInputChange('minimum_sample_size', parseInt(e.target.value))
            }
            inputProps={{ min: 10, max: 10000 }}
            disabled={isActive}
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              },
            }}
          />
        </Grid>

        <Grid
          size={{ xs: 12, md: 1.5 }}
          sx={{ display: 'flex', alignItems: 'flex-end', paddingRight: 0 }}
        >
          <TextField
            fullWidth
            size="small"
            margin="dense"
            label="Statistical Significance"
            type="number"
            value={formData.statistical_significance}
            onChange={e =>
              onInputChange(
                'statistical_significance',
                parseFloat(e.target.value)
              )
            }
            inputProps={{ min: 0.8, max: 0.99, step: 0.01 }}
            disabled={isActive}
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem',
              },
              '& .MuiOutlinedInput-root': {
                borderRadius: 1,
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BasicInformationForm;
